import React, { Component } from 'react';
import GoldStar from '../../images/gold-star.svg'
import GrayStar from '../../images/gray-star.svg'

class RatingsSplit extends Component {
  constructor(props) {
    super(props);
  }
  getStarRows(rating){
    let stars=[];
    for(let i= 1;i<=5;i++){
      if (i <= rating.stars){
        stars.push(<img key={i} className="average-star-img" src={GoldStar} />)
      }
      else{
        stars.push(<img key={i} className="average-star-img" src={GrayStar} />)
      }
    }
    return stars;
  }
  getStarBlocks(){
    const { starsRenderObj } = this.props; 
    const { ratingsBreakUp } = starsRenderObj;
    return(
      ratingsBreakUp.map((rating,index)=>
        <div className="average-star-unit" key={`star-unit-${index}`}>
          <div className="average-rating-text" >
            <div className="average-star-block" >
              {this.getStarRows(rating)}
            </div>
          </div>
          <div className="average-rating-value" >
            <div className="average-value" >
              <span>{rating.value}</span>
            </div>
          </div>
        </div>)
      
    )
  }
  render(){
    const { starsRenderObj } = this.props;
    const headingValueStyle = { backgroundColor: starsRenderObj.headingRatingColor}
    return (
      <div className="ratings-split">
        <div className="average-rating">
          <div className="average-rating-text">
            <p className="average-rating-head">{starsRenderObj.headingTitle}</p>
          </div>
          <div className="average-rating-value" >
            <div className="average-value" style={headingValueStyle}>
              <span>{starsRenderObj.headingRating}</span>
            </div>
          </div>

        </div>
        <div className="average-star-based">Based on {starsRenderObj.totalRatingCount} ratings </div>
        <div className="average-star-wrapper" >
          <div className="average-star-title" >{starsRenderObj.starHeadingTitle}</div>
          {this.getStarBlocks()}
        </div>

      </div>
    )
  }
  
}

export default RatingsSplit;